import { render, staticRenderFns } from "./take-photos-270.vue?vue&type=template&id=36bb85b6&scoped=true&"
import script from "./take-photos-270.vue?vue&type=script&lang=ts&"
export * from "./take-photos-270.vue?vue&type=script&lang=ts&"
import style0 from "./take-photos-270.vue?vue&type=style&index=0&id=36bb85b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb85b6",
  null
  
)

export default component.exports